export default class DictionaryModule {
    
}
